import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import TableLoader from "@/Components/common/TableLoader";
import TableNoContent from "@/Components/common/TableNoContent";
import { POUND_SIGN } from "@/Constants/common";
import { routingConstants } from "@/Constants/routingConstants";
import {
  fetchUnfilledContractShifts,
  fetchUnfilledContracts,
  setUnfilledContractsLoading,
  toggleSelectedAll,
  updatePagination,
  updateSorting,
  updateSelectedContracts,
  updateToggleSelected,
  deSelectAllContract,
  updateSelectedContractRoles,
} from "@/reducers/clientunfilledcontracts";
import {
  expandButtonColumn,
  getActionByHtml,
  getColumnNormalHtml,
} from "@/utilities/datatable/columnFunctions";
import useDebounceScroll from "@/utilities/hooks/useDebounceScroll";

import Actions from "./Actions";
import { FilterModal } from "./FilterModal";
import SearchFilter from "./SearchFilter";
import DataTablePaginationNoUserLoader from "../../../../Skeletons/DataTablePaginationNoUserLoader";
import { ContractsShifts } from "../../candidates/Listing/common/ContractsShifts";
import { SelectedCountText } from "../../candidates/Listing/common/SelectedCountText";

const UnfilledList = () => {
  const dispatch = useDispatch();
  const {
    selectedContracts,
    toggleSelected,
    isLoading,
    pagination,
    unfilledContracts,
    totalCount,
    isSelectedAll,
    isPaginationLoading,
    sorting,
  } = useSelector((state) => state.clientUnfilledContracts);
  const { clientUserAllPermissions } = useSelector((state) => state.session);

  const [data, setData] = useState([]);
  useEffect(() => {
    if (selectedContracts.length === 0) {
      dispatch(updateToggleSelected());
    }
  }, [selectedContracts]);

  useEffect(() => {
    setData(unfilledContracts);
  }, [unfilledContracts]);

  const columns = [
    {
      name: "Reference No.",
      sortable: true,
      sortField: "contract_ref_no",
      selector: (row) => {
        return (
          <div className="grid items-center gap-2" data-tag="allowRowEvents">
            <div className="flex items-center gap-2">
              {!clientUserAllPermissions ||
              clientUserAllPermissions.is_allow_to_view_contract_detail ===
                1 ? (
                <Link
                  to={routingConstants.contractDetail(row.route_contract_id)}
                  className="line-clamp-1 text-[14px] font-semibold leading-[normal] text-black"
                >
                  {row.contract_ref_no}
                </Link>
              ) : (
                <span className="line-clamp-1 cursor-default text-[14px] font-semibold leading-[normal] text-black">
                  {row.contract_ref_no}
                </span>
              )}

              {/* {row.is_for_appLocum_candidates ? (
                row.is_bank_contract ? (
                  <LiveTimerTooltip
                    actionedAt={row.contract_created_at}
                    publisheddAt={row.bank_contract_publish_date}
                  />
                ) : null
              ) : null} */}
            </div>
            {/* <div className="flex  gap-2">

              {!row?.is_substitute_contract ?
                <BankContract
                  contract_tag={row.contract_tag}
                />
                : null
              }
              {row?.is_substitute_contract ? (
                <div className="flex gap-2">
                  <div
                  >
                    {row.contract_tag === "bank" ? (
                      <Tooltip title={TOOLTIPTEXT?.bankContract}>
                        <div className="h-[27px] px-2 py-1 bg-green-200 p-1 text-green_five_color rounded-[4px]">
                          <BankCandidateIcon cls="text-green" />
                        </div>
                      </Tooltip>
                    ) : (
                      <Tooltip title={TOOLTIPTEXT?.appLocumContract}>
                        <div className="h-[27px] px-2 py-1  bg-lightblue text-primary rounded-[4px]">
                          <NonBankCandidateIcon cls="text-primary" />
                        </div>
                      </Tooltip>
                    )}
                  </div>

                  <CoverColleagueTag
                    proposed_candidate_name={row.proposed_candidate_name}
                    proposed_contract_ref={row.proposed_contract_ref}
                    hoverType="shift"
                  />
                </div>
              ) : null}

            </div> */}
          </div>
        );
      },
      width: "13%",
    },

    {
      id: "role-column",
      name: "Role",
      sortable: true,
      // sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "role_name"),
      sortField: "role_name",

      selector: (row) => (
        <div className="flex flex-col" data-tag="allowRowEvents">
          {getColumnNormalHtml(
            row.role_name,
            "line-clamp-2 whitespace-break-spaces",
          )}
        </div>
      ),
      width: "13%",
    },
    {
      name: "Created by",
      // sortable: true,
      // sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "actioned_by"),

      selector: (row) => (
        <div className="flex flex-col" data-tag="allowRowEvents">
          {getActionByHtml(
            row.actioned_by,
            row.actioned_at,
            row.actioned_from,
            "",
          )}
        </div>
      ),
      width: "13%",
    },
    {
      id: "date-range-column",
      name: "Date range",
      sortable: true,
      sortField: "contract_start_date",
      // sortFunction: (rowA, rowB) =>
      //   sortByDate(moment(rowA.contract_start_date, "DD/MM/YYYY hh:mm").format("DD/MM/YYYY"),
      //     moment(rowB.contract_end_date, "DD/MM/YYYY hh:mm").format("DD/MM/YYYY"),
      //   ),
      selector: (row) => (
        <div
          className="flex flex-col items-end gap-1"
          data-tag="allowRowEvents"
        >
          {getColumnNormalHtml(
            moment(row.contract_start_date).format("DD/MM/YYYY"),
          )}
          <span className="leading-[0px]">-</span>
          {getColumnNormalHtml(
            moment(row.contract_end_date).format("DD/MM/YYYY"),
          )}
        </div>
      ),
      width: "12%",
    },
    {
      name: "Shift",
      sortable: true,
      // sortFunction: (rowA, rowB) =>
      //   sortByTime(
      //     moment(rowA.contract_start_time, "HH:mm:ss").format("HH:mm"),
      //     moment(rowB.contract_end_time, "HH:mm:ss").format("HH:mm"),
      //   ),
      sortField: "contract_start_time",
      selector: (row) => (
        <div
          className="flex flex-col items-end gap-1"
          data-tag="allowRowEvents"
        >
          {getColumnNormalHtml(
            moment(row.contract_start_time, "HH:mm:ss").format("HH:mm"),
          )}
          <span className="text-[14px] font-semibold leading-[0px] text-black">
            -
          </span>
          {getColumnNormalHtml(
            moment(row.contract_end_time, "HH:mm:ss").format("HH:mm"),
          )}
        </div>
      ),
      width: "7%",
    },
    {
      name: "Break/Admin",
      sortable: true,
      sortField: "un_paid_break_hour",

      selector: (row) => (
        <div
          className="flex flex-col items-end gap-1"
          data-tag="allowRowEvents"
        >
          {getColumnNormalHtml(
            moment(row.un_paid_break_hour, "HH:mm:ss").format("HH:mm"),
          )}
          <span className="text-[14px] font-semibold leading-[0px] text-black">
            -
          </span>
          {getColumnNormalHtml(
            moment(row.contract_admin_time, "HH:mm:ss").format("HH:mm"),
          )}
        </div>
      ),
      width: "10%",
    },
    {
      name: "Visit",
      sortable: true,
      sortField: "contract_no_of_visit",

      // sortFunction: (rowA, rowB) =>
      //   sortByNumber(rowA, rowB, "contract_no_of_visit"),
      selector: (row) => (
        <div
          className="flex flex-col items-end gap-1"
          data-tag="allowRowEvents"
        >
          {getColumnNormalHtml(
            row.contract_no_of_visit ? row.contract_no_of_visit : 0,
          )}
        </div>
      ),
      width: "7%",
    },
    {
      name: "Days",
      // sortable: true,
      // sortField: 'total_days_of_contract',

      selector: (row) => (
        <div data-tag="allowRowEvents">
          {getColumnNormalHtml(row.total_days_of_contract)}
        </div>
      ),
      width: "6%",
    },
    {
      name: "Total",
      id: "total-column",
      // sortable: true,
      // sortFunction: (rowA, rowB) => sortByNumber(rowA, rowB, "rate"),
      className: "text-right",
      selector: (row) => (
        <div className="flex gap-2" data-tag="allowRowEvents">
          {getColumnNormalHtml(
            `${POUND_SIGN}` +
              Number(
                `${
                  row.rate +
                  (row?.cover_request_awarded_reward
                    ? Number(row?.cover_request_awarded_reward)
                    : 0)
                }`,
              ).toFixed(2),
          )}
          {/* {row?.is_substitute_contract && row?.cover_request_awarded_reward != 0 ?
            <RewardIcon cls={'w-[20px] h-[20px] !text-primary cursor-pointer'} />
            : null} */}
        </div>
      ),
      width: "11%",
    },
    expandButtonColumn(),
  ];
  const dataTableRef = useRef();
  //Comman function for fetching data in list lazy loading
  const handleDebounceScroll = useDebounceScroll(() =>
    dispatch(fetchUnfilledContracts({})),
  );
  useEffect(() => {
    if (dataTableRef.current) {
      const table = dataTableRef.current.querySelector("._DataTable");
      table.addEventListener("scroll", handleDebounceScroll);
      return () => {
        table.removeEventListener("scroll", handleDebounceScroll);
      };
    }
  }, [handleDebounceScroll]);

  const Expandedrow = ({ data }) => (
    <ContractsShifts
      contract_id={data.contract_id}
      shifts={data.shifts}
      substitueCon={data?.is_substitute_contract}
      reward={data?.cover_request_awarded_reward}
    />
  );

  const handleSort = ({ sortField: newSortField }) => {
    const { sortByColumn, sortByOrder } = sorting; // get from Redux

    let newSortOrder = "asc"; // default to ascending
    if (sortByColumn === newSortField) {
      // toggle only if same column clicked again
      newSortOrder = sortByOrder === "asc" ? "desc" : "asc";
    }

    dispatch(setUnfilledContractsLoading(true));
    dispatch(deSelectAllContract());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(
      updateSorting({ sortByColumn: newSortField, sortByOrder: newSortOrder }),
    );
    dispatch(fetchUnfilledContracts());
  };

  return (
    <div className="UnfilledList_Wrapper mb-[58px]">
      <div className="flex h-full flex-col rounded-[10px] bg-white p-4 shadow-[0px_x1px_6px_0px_#E7EFFB]">
        <div className="mb-[20px] flex flex-col flex-wrap gap-3 border-b border-b-[#E8E8E8] pb-[11px] md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-2 md:gap-[21px]">
            <h4 className="main-heading tour-unfilled-heading font-semibold leading-[normal] text-black">
              Unfilled Contracts
            </h4>
            <Actions />
            <SelectedCountText
              selectedCount={selectedContracts.length}
              totalCount={totalCount}
              isSelectedAll={isSelectedAll}
              clearSelected={() => {
                dispatch(updateToggleSelected());
              }}
              handleSelectAll={(val) => {
                dispatch(toggleSelectedAll(val));
              }}
              updateSelected={(val) => {
                dispatch(updateSelectedContracts(val));
              }}
              currentDataLength={data.length}
            />
          </div>
          <div className="flex gap-[20px]">
            <SearchFilter />
            <FilterModal />
          </div>
        </div>
        <div
          className="DataTable_Wrapper hide_extended_arrow"
          ref={dataTableRef}
        >
          <DataTable
            columns={columns}
            data={data}
            fixedHeader
            onSort={handleSort}
            // persistTableHead={true}

            fixedHeaderScrollHeight="600px"
            progressPending={isLoading}
            progressComponent={<TableLoader rows={5} />}
            selectableRows
            onSelectedRowsChange={(state) => {
              let selectedIDS = state.selectedRows.map((item) => {
                return item.contract_id;
              });
              let selectRole = state.selectedRows.map((item) => {
                return item.session_type_id;
              });
              dispatch(updateSelectedContracts(selectedIDS));
              dispatch(updateSelectedContractRoles(selectRole));
            }}
            noDataComponent={<TableNoContent />}
            clearSelectedRows={toggleSelected}
            className="_DataTable"
            expandableRows
            expandOnRowClicked
            expandableRowsComponent={Expandedrow}
            onRowExpandToggled={(state, row) => {
              if (state) {
                dispatch(
                  fetchUnfilledContractShifts({
                    contract_id: row.contract_id,
                    forExpand: 1,
                  }),
                );
              }
            }}
          />
        </div>
        {!isLoading && isPaginationLoading ? (
          <DataTablePaginationNoUserLoader />
        ) : null}
      </div>
    </div>
  );
};

export default UnfilledList;
